import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { AddUpdateSessioneOlaStudenteCommand } from '../../model/command-model';
import { AStudenteService } from '../../pages/administrator-page/studente/a-studente.service';
import { SelectDTO } from 'src/app/model/newModel';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-add-ora-laboratorio-modal',
  templateUrl: './add-ora-laboratorio-modal.component.html',
  styleUrls: ['./add-ora-laboratorio-modal.component.css'],
})
export class AddOraLaboratorioModalComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  laboratori: SelectDTO[];
  idLaboratorio: SelectDTO;
  matricola: number;
  nomeCompletoStudente: String;
  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private aStudenteService: AStudenteService,
    private sharedService: SharedService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    this.loadLaboratori();
    super.ngAfterViewInit();
  }

  loadLaboratori() {
    this.sharedService.selectLaboratori().subscribe(
      (result) => {
        this.laboratori = result.list;
      },
      (error) => {
        console.log('Errore selectLaboratori');
      }
    );
  }

  aggiungiOraLaboratorio(idLaboratorio: number) {
    if(!!idLaboratorio) {
    const command = new AddUpdateSessioneOlaStudenteCommand();
    const idStudente = (<any>document.getElementById('idStudente')).value;
    command.idStudente = Number(idStudente);
    command.idLaboratorio = idLaboratorio;
    command.oreInLaboratorio = 1;
    if (!!idStudente) {
      this.aStudenteService.aggiungiOraLaboratorio(command).subscribe(
        (result) => {
          this.ngxSmartModalService
            .getModal('addOraLaboratorioModalComponent')
            .close();
          this.matricola = null;
          this.idLaboratorio = null;
          this.nomeCompletoStudente = null;
          if (result) {
            this.sharedService.openOkModal();
            this.modalSubscribe = this.ngxSmartModalService
              .getModal('okModal')
              .onClose.subscribe((modal: NgxSmartModalComponent) => {
                window.location.reload();
              });
          } else {
            const text =
              'Ora già registrata per questo studente per il laboratorio scelto!';
            this.sharedService.openWarningModal(text);
          }
        },
        (error) => {
          this.matricola = null;
          this.idLaboratorio = null;
          this.nomeCompletoStudente = null;
          this.ngxSmartModalService
            .getModal('addOraLaboratorioModalComponent')
            .close();
          console.log('Errore aggiungiOraLaboratorio');
        }
      );
    }
  } else {
    this.ngxSmartModalService
    .getModal('addOraLaboratorioModalComponent')
    .close();
    this.sharedService.openWarningModal(
      'Selezionare il laboratorio'
    );
  }
}
}
